module.exports = __webpack_public_path__ + "static/media/goals-secondary.d5048879.svg";